import application from 'application/application';

const controller = 'DefaultPublicationsProcessesDetailsController';

application

	.controller(controller, ['$rootScope', '$scope', '$state', '$stateParams', 'helper', '$http', 'API', 'ngNotify', ($rootScope, $scope, $state, $stateParams, helper, $http, API, ngNotify) => {

		$scope.ProcessIDs = $stateParams.id;

		/** Instância de armazenamento de resposta. */
		$scope.processInfo = helper.responseStore()
			.setItemsPerPage(10)
			.setCurrentPage($stateParams.paginaAtual);

		/** Instância de armazenamento de resposta. */
		$scope.movements = helper.responseStore()
			.setItemsPerPage(20)
			.setCurrentPage($stateParams.paginaAtual);

		$scope.infos = helper.responseStore()
			.setItemsPerPage(10)
			.setCurrentPage($stateParams.paginaAtual);

		$scope.processLawyers = [];
		$scope.processSide = [];

		$scope.groupUserData = JSON.parse(localStorage.getItem('__groupUserData__'));
		$scope.groupSelected = JSON.parse(localStorage.getItem('__groupSelected__'));
		$scope.userData = JSON.parse(localStorage.getItem('__authenticationUserData__'));


		// transformar tudo isso em um obj só contendo tudo dps
		$scope.limit = 20;
		$scope.scrollPage = 2;
		$scope.canScroll = true;
		$scope.atMoviments = false;
		$scope.loading = false;

		$scope.recordProcessInfo = (responseStore) => {

			let paramsSearch = {
				campos: '*',
				registrosPorPagina: 20,
				IdProcesso: $scope.ProcessIDs,
				IdUsuarioCliente: $stateParams.idUsuarioCliente
			};

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.processes, 'font'),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					if (response.data.itens[0]) {
						responseStore.setItems(response.data.itens[0]);
					}
				});
		};

		$scope.recordProcessInfo($scope.processInfo);

		$scope.recordLawyers = () => {

			let paramsSearch = {
				ids: $scope.ProcessIDs,
				idFonteProcesso: $stateParams.idFonteProc,
				IdUsuarioCliente: $stateParams.idUsuarioCliente
			};

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.processHeaders),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					if (response.data.itens[0].fontesProcesso[0].tiposSujeitos)
						response.data.itens[0].fontesProcesso[0].tiposSujeitos.forEach(item => {
							item.sujeitos.forEach(parte => {
								parte.nomeTipoSujeitoProcesso = item.nomeTipoSujeito;
								if (parte.idTipoSujeitoProcesso == -3)
									$scope.processLawyers.push(parte);
								else
									$scope.processSide.push(parte);
							});
						});
				});
		};

		$scope.recordLawyers();

		$scope.recordMovements = (responseStore) => {

			let paramsSearch = {
				idFonteProcesso: $stateParams.idFonteProc,
				idPastaUsuarioCliente: $stateParams.idPastaUsuarioCliente,
				registrosPorPagina: $scope.movements.getItemsPerPage(),
				paginaAtual: $scope.movements.getCurrentPage()
			};

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.movements),
				method: 'GET',
				params: paramsSearch
			})
				.then((response) => {
					const movements = response.data.itens.map(item => {
						return { ...item, checked: false };
					});

					if (movements.length < $scope.movements.getItemsPerPage()) $scope.canScroll = false;
					responseStore.setItems(movements);
				});
		};


		$scope.recordMovements($scope.movements);

		$scope.recordInfos = (responseStore) => {
			$http({
				...helper.http(API.processes, 'additionalInfo'),
				method: 'GET',
				params: {
					campos: '*',
					registrosPorPagina: 20,
					IdProcesso: $scope.ProcessIDs,
					IdCliente: $stateParams.idCliente,
					IdUsuarioCliente: $stateParams.idUsuarioCliente,
					ativo: true
				}
			})
				.then((response) => {

					const infos = response.data.itens;

					responseStore.setItems(infos);
				});
		};

		$scope.recordInfos($scope.infos);

		$scope.activeItem = status => {

			$('.nav.nav-tabs li').removeClass('active');

			$(status).parent().addClass('active');
			(status === '#movements-tab') ? $('#sendmail').removeClass('d-none') : $('#sendmail').addClass('d-none');

			if (status === '#movements-tab') {
				$scope.markAsRead($scope.movements.items);
				$scope.atMoviments = true;
			} else {
				if ($scope.atMoviments) {
					$scope.recordMovements($scope.movements);
					$scope.scrollPage = 2;
					$scope.canScroll = true;
					$scope.atMoviments = false;
					$scope.loading = false;
				}
				$scope.atMoviments = false;
			}
		};


		$scope.openModalEmail = () => {

			const el = $('#modalSendEmail');

			el.modal && el.modal('show');
		};

		$scope.checkedItems = () => {
			const checked = $scope.movements.items.filter(item => item.checked);

			return checked.length > 0 ? true : false;

		};

		$scope.sendByEmail = (email) => {
			const checkedMovements = $scope.movements.items.filter(item => item.checked);
			const ids = checkedMovements.map(item => item.movimento.id).join(',');
			const emails = email.trim().split(';');

			let paramsSearch = {
				idsMovimentos: ids,
				destinatarios: emails,
				idUsuarioMovimento: $stateParams.idUsuarioCliente
			};

			if ($scope.groupSelected) {
				paramsSearch.idGrupoMovimento = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.email, 'movements'),
				method: 'POST',
				data: paramsSearch
			})
				.then(() => {
					$scope.email = '';
					$scope.$resetFormValidation('sendEmail')();
					$('#modalSendEmail').modal('hide');

					$scope.movements.items.forEach(movement => movement.checked = false);
				});
		};

		/**
	 * Verifica se existe uma página anterior à atual.
	 */
		$scope.hasMovementsPrevPage = () => ($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		/**
		 * Navega para a primeira página.
		 */

		/**
		 * Navega para a primeira página.
		 */
		$scope.recordMovementsFirstPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a ultima página.
		 */
		$scope.recordMovementsLastPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = $scope.movementsPagesLength;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a página anterior.
		 */
		$scope.recordMovementsPrevPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			let currentPage = params.paginaAtual ? Number(params.paginaAtual) : 1;

			params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a próxima página.
		 */
		$scope.recordMovementsNextPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = params.paginaAtual ? Number(params.paginaAtual) + 1 : 2;

			$state.go($state.current.name, params, { inherit: false });

		};

		$scope.loadMore = function() {
			if ($scope.canScroll && $scope.atMoviments) {

				$scope.movements.items.forEach(movement => movement.lido = true);

				$scope.loading= true;
				$scope.limit += 20;
				$scope.recordMovementsScrollDown();
			}
		};

		$scope.recordMovementsScrollDown = () => {
			let params = helper.cloneSimpleObject($stateParams);

			$scope.scrollPage += 1;

			params['#'] = 'movements';
			$scope.recordMovementsScroll($scope.movements, $scope.scrollPage);

		};

		$scope.recordMovementsScroll = (responseStore, pagina) => {
			$http({
				...helper.http(API.movements),
				method: 'GET',
				params: {
					campos: '*',
					idFonteProcesso: $stateParams.idFonteProc,
					idPastaUsuarioCliente: $stateParams.idPastaUsuarioCliente,
					idUsuarioCliente: $stateParams.idUsuarioCliente,
					registrosPorPagina: 20,
					paginaAtual: pagina,
					IdGrupoUsuarios: $stateParams.idGrupo
				}
			})
				.then((response) => {
					$scope.markAsRead(response.data.itens);
					const movements = [...$scope.movements.items,...response.data.itens.map(item => {
						return { ...item, checked: false };
					})];

					responseStore.setItems(movements);
					$scope.canScroll = (response.data.itens.length >= 20);
					$scope.loading = false;
				});
		};

		$scope.markAsRead = (movements) => {

			const notReadMovements = movements.filter(movement => !movement.lido)
				.map(andamento => ({
					id: andamento.id,
					idUsuarioCliente: +$scope.userData.idUsuarioCliente,
					idMovProcessoCliente: andamento.idMovProcessoCliente
				}));


			if (notReadMovements.length) {
				$http({
					...helper.http(API.processes, 'setAsRead'),
					method: 'PUT',
					data: {
						itens: notReadMovements
					},
					messageOverride: {
						success() {
							ngNotify.set('Andamentos marcados como lido', {
								type: 'success',
								position: 'bottom'
							});
						}
					}
				});
			}

		};

		$scope.selectTab = 'process';

		$scope.changeTab = (tab) => {

			if ($scope.selectTab) $(`#${$scope.selectTab}`).removeClass('active show');

			$scope.selectTab = tab;

			$(`#${tab}`).addClass('active show');
		};

	}]);

export default controller;
